export enum RepresentationTypeGraphQL {
  FREELANCE = 'non_represented',
  AGENCY_REPRESENTATION = 'agency_representation',
  BLANK = '',
}
